import {CUSTOM_ELEMENTS_SCHEMA, NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {NgSelectModule} from "@ng-select/ng-select";
import {FormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {AngularSvgIconModule} from "angular-svg-icon";
import {TranslateModule} from "@ngx-translate/core";
import {
  AgentInventorySettingsTableComponent
} from "./components/agent-inventory-settings-table/agent-inventory-settings-table.component";
import {
  AgentInventorySettingsTableRowComponent
} from "./components/agent-inventory-settings-table-row/agent-inventory-settings-table-row.component";
import {$timeoutServiceProvider, confirmDialogServiceProvider, agentInventoryDialogServiceProvider, splitServiceProvider} from "../../../providers";

@NgModule({
  declarations: [
    AgentInventorySettingsTableComponent,
    AgentInventorySettingsTableRowComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ScrollingModule,
    CommonsModule,
    AngularSvgIconModule.forRoot(),
    TranslateModule.forRoot(),
    NgbModule,
    NgxPermissionsModule.forChild(),
    NgSelectModule,
    FormsModule
  ],
  providers: [
    $timeoutServiceProvider,
    confirmDialogServiceProvider,
    splitServiceProvider,
    agentInventoryDialogServiceProvider
  ],
  exports: [
    AgentInventorySettingsTableComponent,
    AgentInventorySettingsTableRowComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AgentInventoryModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapAgentInventoryModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AgentInventoryModule);
};

export const downgradedAgentInventoryModule = downgradeModule(bootstrapAgentInventoryModule);
